// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const IntentSignalsPage = lazy(() => import('./pages/IntentSignalsPage'));
const CompetitorTrackingPage = lazy(() => import('./pages/CompetitorTrackingPage'));
const AccountIntelligencePage = lazy(() => import('./pages/AccountIntelligencePage'));
const ContactEnrichmentPage = lazy(() => import('./pages/ContactEnrichmentPage'));
const PredictiveScoringPage = lazy(() => import('./pages/PredictiveScoringPage'));
const DealHealthPage = lazy(() => import('./pages/DealHealthPage'));

export const IntelligenceRoutes: RouteObject = {
  path: 'intelligence',
  element: <ModuleGuard moduleId="sales.intelligence" />,
  children: [
    { path: 'intent-signals', element: <IntentSignalsPage />, handle: { crumb: 'Intent Signals' } },
    { path: 'competitor-tracking', element: <CompetitorTrackingPage />, handle: { crumb: 'Competitor Tracking' } },
    { path: 'account-intelligence', element: <AccountIntelligencePage />, handle: { crumb: 'Account Intelligence' } },
    { path: 'contact-enrichment', element: <ContactEnrichmentPage />, handle: { crumb: 'Contact Enrichment' } },
    { path: 'predictive-scoring', element: <PredictiveScoringPage />, handle: { crumb: 'Predictive Scoring' } },
    { path: 'deal-health', element: <DealHealthPage />, handle: { crumb: 'Deal Health' } },
  ],
};
